const el = {
  header: {
    home: 'Αρχική',
    changePassword: 'Αλλαγή Κωδικού',
    giveFeedback: 'Give Feedback',
    orgSettings: 'Ρυθμίσεις Οργανισμού',
    superAdmin: 'Super Admin Panel',
    createOrg: 'Νέος Οργανισμός',
    logout: 'Αποσύνδεση',
    languageLabel: 'GR',
    languageMenu: { el: 'Ελληνικά', en: 'English' },
  },

  notifications: {
    title: 'Ειδοποιήσεις',
    markAllRead: 'Σήμανση όλων ως αναγνωσμένων',
    empty: 'Δεν έχεις νέες ειδοποιήσεις',
    welcomeTitle: 'Καλωσόρισες στο eazyproject 👋',
    welcomeMessage: 'Ρίξε μια ματιά στα έργα στα οποία έχεις πρόσβαση.',
    taskAssignedTitle: 'Σου ανατέθηκε μια εργασία',
    taskAssignedMessage: (task: string, project: string) => `«${task}» στο έργο «${project}»`,
    invitedOrgTitle: 'Προστέθηκες σε νέο οργανισμό',
    invitedOrgMessage: (org: string) => `Έγινες μέλος του οργανισμού «${org}»`,
    invitedProjectTitle: 'Προστέθηκες σε νέο έργο',
    invitedProjectMessage: (project: string, org: string) => `Έγινες μέλος του έργου «${project}» (${org})`,
  },

  createOrg: {
    title: 'Νέος Οργανισμός',
    subtitle: 'Δημιούργησε τον δικό σου οργανισμό στο eazyproject',
    nameLabel: 'Όνομα οργανισμού',
    namePh: 'π.χ. Εταιρεία ΑΒΓ',
    choosePlan: 'Επίλεξε πλάνο',
    trialName: 'Δωρεάν δοκιμή',
    trialSub: '10 ημέρες πλήρης πρόσβαση · Χωρίς κάρτα',
    trialPrice: 'ΔΩΡΕΑΝ',
    popular: 'ΔΗΜΟΦΙΛΕΣ',
    btnTrial: 'Έναρξη δωρεάν δοκιμής →',
    btnPaid: 'Συνέχεια στην πληρωμή →',
    creating: 'Δημιουργία...',
  },

  dashboard: {
    loading: 'Φόρτωση...',
    projectsTitle: 'Έργα σε εξέλιξη',
    manageUsers: '👥 Διαχείριση Χρηστών',
    newProject: '+ Νέο έργο',
    newProjectFirst: '+ Δημιούργησε το πρώτο σου έργο',
    noActive: 'Δεν υπάρχουν ενεργά έργα.',
    planLimitTooltip: (max: number) => `Όριο πλάνου: ${max} έργα`,
    archiveBadge: 'ΑΡΧΕΙΟ',
    tooltipTitle: 'Στοιχεία έργου',
    tooltipStatus: 'Κατάσταση',
    tooltipBudget: 'Budget',
    tooltipDuration: (months: number) => `${months} μήνες`,
    tooltipOpenIssues: 'Ανοιχτά issues',
    tooltipHighRisks: 'Risks high',
    tooltipType: 'Τύπος',
    openProject: 'Άνοιγμα →',
    restoreTip: 'Επαναφορά στα ενεργά',
    dragRestore: 'Σύρε ή πάτα ↩ για επαναφορά',
    archiveSection: 'Ολοκληρωμένα · Αρχειοθετημένα',
    archiveDragHint: '↩ Σύρε ένα έργο στην περιοχή των ενεργών ή πάτα το κουμπί επαναφοράς για να το επαναφέρεις',
    guestSection: 'Έργα Εκτός Οργανισμού',
    menuArchive: '📦 Αρχειοθέτηση',
    menuDelete: 'Διαγραφή έργου',
    healthProblem: 'Σε πρόβλημα',
    healthRisk: 'Σε ρίσκο',
    healthOk: 'Εντός πλαισίου',
    planLimitTitle: 'Έχετε φτάσει το όριο έργων του πλάνου σας',
    planLimitAdmin: (max: number, unit: string) => `Το πλάνο σας επιτρέπει έως ${max} ${unit}. Αναβαθμίστε για να δημιουργήσετε νέα έργα.`,
    planLimitMember: (max: number, unit: string) => `Το πλάνο του οργανισμού επιτρέπει έως ${max} ${unit}. Επικοινωνήστε με τον διαχειριστή για αναβάθμιση του πακέτου συνδρομής.`,
    planLimitUpgrade: 'Αναβάθμιση πλάνου →',
    planLimitProject: (n: number): string => n === 1 ? 'έργο' : 'έργα',
    ragTitle: (count: number, name: string) => `Το AI χρησιμοποίησε ${count} παρόμοια έργα ως βάση ανάλυσης για το "${name}"`,
    ragNote: 'Τα risks, schedule και budget του νέου έργου έχουν εμπλουτιστεί με δεδομένα από αυτά τα έργα.',
    ragView: 'Προβολή →',
    newProjectModal: 'Νέο Έργο',
    noAiKeyMsg: '⚠️ Δεν έχει οριστεί AI key — οι AI λειτουργίες δεν θα είναι διαθέσιμες.',
    addKeyNow: 'Προσθήκη τώρα →',
    howToGetKey: 'Πώς να αποκτήσω AI key;',
    fieldTitle: 'Τίτλος Έργου *',
    titlePlaceholder: 'π.χ. Κατασκευή Γέφυρας Α1',
    fieldDescription: 'Περιγραφή',
    descPlaceholder: 'Σύντομη περιγραφή...',
    docSection: 'Έγγραφο Έργου',
    docLimit: 'PDF · DOCX · έως 30 MB',
    docHint: 'Το AI αναλύει τη σύμβαση και δημιουργεί αυτόματα την αρχική εικόνα του έργου.',
    contractLabel: 'Σύμβαση / Τεχνική Πρόταση *',
    contractPlaceholder: '📎 Επέλεξε αρχείο',
    docNote: '💡 Για καλύτερη ανάλυση, ανεβάστε έγγραφο διαχείρισης έργου — σύμβαση, τεχνική πρόταση ή τεύχος προδιαγραφών.',
    aiAnalyzing: '✦ Το AI αναλύει τα έγγραφα και ψάχνει παρόμοια έργα...',
    loadingSteps: [
      'Δημιουργία έργου',
      'Ανάγνωση εγγράφου',
      'Ανάλυση σύμβασης...',
      'Δημιουργία modules έργου',
    ],
    cancel: 'Ακύρωση',
    creating: 'Δημιουργία...',
    createBtn: 'Δημιουργία Έργου',
    errorRequired: 'Το όνομα έργου είναι υποχρεωτικό',
    errorNoContract: 'Παρακαλώ ανεβάστε το έγγραφο σύμβασης',
    errorFileTooLarge: 'Το αρχείο υπερβαίνει το όριο των 30 MB.',
    errorCreate: 'Σφάλμα κατά τη δημιουργία του έργου',
    deleteTitle: 'Διαγραφή Έργου',
    deleteAbout: 'Πρόκειται να διαγράψεις οριστικά το έργο:',
    deleteIrreversible: 'Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    deleteConfirmLabel: 'Πληκτρολόγησε',
    deleteConfirmWord: 'Διαγραφή',
    deleting: 'Διαγραφή...',
    deleteBtn: 'Διαγραφή Έργου',
    archiveTitle: 'Αρχειοθέτηση Έργου',
    archiveAbout: 'Πρόκειται να αρχειοθετήσεις το έργο:',
    archiveHint: '💡 Στο επόμενο βήμα θα καταγράψεις τα Lessons Learned του έργου.',
    archiveContinue: 'Συνέχεια → Lessons Learned',
    lessonsTitle: 'Lessons Learned',
    lessonsType: 'Τύπος Έργου',
    lessonsTypePlaceholder: 'π.χ. SaaS Ανάπτυξη...',
    lessonsIndustry: 'Κλάδος',
    lessonsIndustryPh: 'π.χ. Δημόσιος Τομέας, Τηλεπικοινωνίες...',
    lessonsRating: 'Συνολική Αξιολόγηση:',
    lessonsRatingBad: '1 Κακό',
    lessonsRatingMid: '3 Μέτριο',
    lessonsRatingGood: '5 Εξαιρετικό',
    lessonsTags: 'Κύριες Προκλήσεις',
    lessonsWentWell: 'Τι πήγε καλά;',
    lessonsWentWellPh: 'Πρακτική που λειτούργησε...',
    lessonsWentWrong: 'Τι δεν πήγε καλά;',
    lessonsWentWrongPh: 'Πρόβλημα που προέκυψε...',
    lessonsKeyLessons: 'Κύρια Μαθήματα',
    lessonsLessonPh: (i: number) => `Μάθημα ${i + 1}...`,
    lessonsWouldDo: 'Τι θα έκανες διαφορετικά;',
    lessonsWouldDoPh: 'Αν ξεκινούσες από την αρχή...',
    lessonsAdd: '+ Προσθήκη',
    lessonsBack: '← Πίσω',
    lessonsComplete: 'Ολοκλήρωση & Αρχειοθέτηση',
    archiving: 'Αρχειοθέτηση...',
    portfolioSearch: 'Portfolio Search',
    portfolioTitle: 'Portfolio Search',
    portfolioSubtitle: 'Αναζήτηση μαθημάτων από αρχειοθετημένα έργα του οργανισμού σου',
    portfolioSearchPh: 'Περίγραψε το νέο σου έργο ή αναζήτησε κατά κλάδο...',
    portfolioSearchBtn: 'Αναζήτηση',
    portfolioNoProjects: 'Δεν υπάρχουν αρχειοθετημένα έργα με καταγεγραμμένα Lessons Learned.',
    portfolioNoResults: 'Δεν βρέθηκαν αποτελέσματα για αυτή την αναζήτηση.',
    portfolioFallbackNote: 'Αναζήτηση χωρίς AI — δεν έχει ρυθμιστεί AI key.',
    portfolioAiNote: 'Αποτελέσματα βασισμένα σε AI ανάλυση.',
    portfolioMatchScore: 'Συνάφεια',
    aiKeyTitle: 'Πώς να αποκτήσω AI key;',
    aiKeySteps: [
      {
        title: 'Επιλέξτε πάροχο AI',
        body: 'Υποστηρίζουμε OpenAI (GPT models) και Anthropic (Claude). Δημιουργήστε λογαριασμό στον πάροχο της επιλογής σας:',
      },
      {
        title: 'Προσθέστε τρόπο πληρωμής',
        body: 'Το API key δεν λειτουργεί χωρίς ενεργό χρεωστικό υπόλοιπο. Μεταβείτε στις ρυθμίσεις χρέωσης του παρόχου σας και προσθέστε κάρτα ή αγοράστε credits.',
        note: 'Το κόστος χρήσης είναι πολύ χαμηλό — συνήθως μερικά λεπτά ανά ανάλυση εγγράφου.',
      },
      {
        title: 'Δημιουργήστε API key',
        body: 'Στο dashboard του παρόχου: API Keys → Create new key. Αντιγράψτε το key — εμφανίζεται μόνο μία φορά.',
      },
      {
        title: 'Επικολλήστε το key εδώ',
        body: 'Ρυθμίσεις Οργανισμού → AI Ρυθμίσεις → επικολλήστε το key, επιλέξτε μοντέλο → Αποθήκευση.',
      },
    ],
    aiKeyGoSettings: 'Πήγαινε στις Ρυθμίσεις →',
  },

  projectHub: {
    loading: 'Φόρτωση...',
    myProjects: 'Τα έργα μου',
    saving: 'Αποθήκευση...',
    editNameTitle: 'Επεξεργασία ονόματος',
    active: 'Ενεργό',
    groupPlanning: 'ΣΧΕΔΙΑΣΜΟΣ & ΕΚΚΙΝΗΣΗ',
    groupExecution: 'ΕΚΤΕΛΕΣΗ & ΠΑΡΑΚΟΛΟΥΘΗΣΗ',
    groupAI: 'AI & ΕΓΓΡΑΦΑ',
    startDate: 'Έναρξη:',
    endDate: 'Λήξη:',
    aiAssistantTitle: 'AI Βοηθός',
    chatExpand: 'Μεγέθυνση',
    chatCollapse: 'Σμίκρυνση',
    thinking: '✦ Σκέφτομαι...',
    chatPlaceholder: 'Ρώτησε κάτι για το έργο...',
    chatError: 'Παρουσιάστηκε σφάλμα.',
    chatGreeting: (name: string) => `Γεια! Είμαι ο AI Βοηθός του έργου **${name}**.\n\nΠώς μπορώ να βοηθήσω;`,
    quickQuestions: ['Πώς πάει το έργο;', 'Ποια είναι τα ρίσκα;', 'Υπάρχουν ανοιχτά issues;'] as [string, string, string],
    statRisks: (n: number) => `${n} ρίσκα`,
    statCritical: (n: number) => `${n} κρίσιμα`,
    statPhase: (n: number) => `Φάση ${n}`,
    statSchedule: (phases: number, activities: number) => `${phases} φάσεις · ${activities} activities`,
    statOpenIssues: (n: number) => `${n} ανοιχτά`,
    statOverdue: (n: number) => `${n} overdue`,
    statMembers: (n: number) => `${n} μέλη`,
    moduleDescriptions: {} as Record<string, string>,
    dateLocale: 'el-GR',
  },

  userManagement: {
    breadcrumbTitle: 'Διαχείριση Χρηστών',
    panelTitle: 'Χρήστες',
    newUserBtn: '+ Νέος',
    loading: 'Φόρτωση...',
    planLimitMsg: (max: number) => `Έχετε φτάσει το μέγιστο ${max} χρηστών του πλάνου σας. Αναβαθμίστε για να προσθέσετε περισσότερους.`,
    emptyState: 'Επέλεξε έναν χρήστη για να διαχειριστείς τα δικαιώματά του',
    manageTitle: (name: string) => `Διαχείριση — ${name}`,
    fullAccessRole: (role: string) => `Ο ρόλος ${role} έχει αυτόματα πρόσβαση σε όλα τα έργα και modules.`,
    tabProjects: '🏗️ Πρόσβαση σε Έργα',
    tabModules: '🔧 Δικαιώματα Modules',
    projectsDesc: 'Επέλεξε σε ποια έργα έχει πρόσβαση ο χρήστης.',
    addToProject: 'Προσθήκη',
    removeFromProject: 'Αφαίρεση',
    selectProjectLabel: 'Επέλεξε Έργο:',
    selectProjectPlaceholder: '-- Επέλεξε έργο --',
    noProjectsWarning: '⚠️ Πρόσθεσε πρώτα τον χρήστη σε ένα έργο από την καρτέλα "Πρόσβαση σε Έργα".',
    newUserTitle: 'Νέος Χρήστης',
    emailLabel: 'Email *',
    checking: 'Έλεγχος...',
    alreadyInOrg: '⚠️ Ο χρήστης ανήκει ήδη στον οργανισμό σας.',
    close: 'Κλείσιμο',
    userFoundTitle: (name: string) => `Ο χρήστης ${name} βρέθηκε στο σύστημα.`,
    userFoundDesc: 'Θα προσκληθεί στον οργανισμό σας και θα αποκτήσει πρόσβαση στο επιλεγμένο έργο.',
    orgRoleLabel: 'Ρόλος στον οργανισμό *',
    accessProjectLabel: 'Έργο πρόσβασης',
    accessProjectOptional: '(προαιρετικό)',
    noProjectOption: '-- Χωρίς συγκεκριμένο έργο --',
    pmProjectsLabel: 'Πρόσβαση σε Έργα (PM) *',
    pmProjectsHint: 'Ο PM θα έχει πλήρη δικαιώματα μόνο στα έργα που θα επιλέξεις εδώ.',
    pmProjectsEmpty: 'Δεν υπάρχουν έργα ακόμα.',
    cancel: 'Ακύρωση',
    inviting: 'Πρόσκληση...',
    invite: 'Πρόσκληση',
    nameLabel: 'Ονοματεπώνυμο *',
    namePlaceholder: 'π.χ. Γιώργος Παπαδόπουλος',
    passwordLabel: 'Κωδικός *',
    roleLabel: 'Ρόλος *',
    emailNote: '📧 Θα αποσταλεί email με τα στοιχεία σύνδεσης στον χρήστη.',
    creating: 'Δημιουργία...',
    create: 'Δημιουργία',
    editTitle: 'Επεξεργασία Χρήστη',
    saving: 'Αποθήκευση...',
    save: 'Αποθήκευση',
    deleteTitle: 'Διαγραφή Χρήστη',
    deleteIrreversible: 'Αυτή η ενέργεια δεν αναιρείται',
    deleteWarning: 'Ο χρήστης θα διαγραφεί μαζί με όλα τα δικαιώματά του από όλα τα έργα.',
    deleting: 'Διαγραφή...',
    deleteBtn: 'Διαγραφή',
    errorRequired: 'Όλα τα πεδία είναι υποχρεωτικά',
    errorCreate: 'Σφάλμα κατά τη δημιουργία χρήστη',
    errorUpdate: 'Σφάλμα κατά την ενημέρωση',
    errorInvite: 'Σφάλμα κατά την πρόσκληση',
    editTip: 'Επεξεργασία',
  },

  app: {
    subscriptionExpiredTitle: 'Η συνδρομή σας έχει λήξει',
    subscriptionExpiredDesc: 'Τα δεδομένα σας είναι ασφαλή και διατηρούνται πλήρως.',
    subscriptionExpiredNote: 'Ανανεώστε τη συνδρομή σας για να αποκτήσετε πρόσβαση.',
    renewBtn: 'Ανανέωση Συνδρομής →',
    logout: 'Αποσύνδεση',
    trialExpiredTitle: 'Αποκτήστε το πακέτο συνδρομής που σας ταιριάζει',
    trialExpiredDesc: 'Η δωρεάν δοκιμή σας έληξε. Επιλέξτε πλάνο για πλήρη πρόσβαση.',
    selectPlanTitle: 'Επιλέξτε Πλάνο',
    selectPlanDesc: 'Η χρέωση ξεκινά αμέσως μετά την ολοκλήρωση της πληρωμής.',
    planLimitsText: (maxProjects: any, maxUsers: any) => `${maxProjects ?? '∞'} έργα · ${maxUsers ?? '∞'} χρήστες`,
    popular: 'ΔΗΜΟΦΙΛΕΣ',
    perMonth: '/μήνα',
    redirecting: 'Ανακατεύθυνση...',
    select: 'Επιλογή',
    backBtn: '← Πίσω',
    errorCheckout: 'Σφάλμα κατά την ανακατεύθυνση στο checkout',
  },

  profileEdit: {
    title: 'Το Προφίλ μου',
    roleLabel: 'Ρόλος',
    sectionTitle: 'Αλλαγή Κωδικού',
    currentPassword: 'Τρέχων κωδικός',
    newPassword: 'Νέος κωδικός',
    confirmPassword: 'Επιβεβαίωση νέου κωδικού',
    newPasswordPlaceholder: 'Τουλάχιστον 6 χαρακτήρες',
    close: 'Κλείσιμο',
    saving: 'Αποθήκευση...',
    changeBtn: 'Αλλαγή Κωδικού',
    errorRequired: 'Όλα τα πεδία είναι υποχρεωτικά',
    errorMinLength: 'Ο νέος κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες',
    errorMismatch: 'Οι κωδικοί δεν ταιριάζουν',
    successMsg: 'Ο κωδικός άλλαξε επιτυχώς!',
    errorGeneric: 'Σφάλμα κατά την αλλαγή κωδικού',
  },

  onboarding: {
    errorGeneric: 'Κάτι πήγε στραβά. Δοκιμάστε ξανά.',
    welcomeTitle: 'Καλωσήρθατε στο eazyproject!',
    welcomeSubtitle: (name: string) => `Ο οργανισμός ${name} είναι έτοιμος. Ας σας βοηθήσουμε να ξεκινήσετε σε 2 γρήγορα βήματα.`,
    welcomeBtn: 'Ξεκινάμε →',
    aiTitle: 'Ενεργοποιήστε το AI',
    aiSubtitle: 'Το AI αναλύει έγγραφα, εντοπίζει κινδύνους και σας δίνει συμβουλές σε πραγματικό χρόνο. Χρειάζεστε ένα API key — διαρκεί ',
    aiSubtitleBold: '2 λεπτά',
    aiSubtitleEnd: ' και πληρώνετε μόνο ό,τι χρησιμοποιείτε.',
    creditsNote: 'Βεβαιωθείτε ότι υπάρχουν credits στο λογαριασμό σας (',
    creditsLink: 'διαχείριση credits',
    creditsNoteEnd: ')',
    saveAndContinue: 'Αποθήκευση & Συνέχεια →',
    continueBtn: 'Συνέχεια →',
    saving: 'Αποθήκευση...',
    laterBtn: 'Αργότερα',
    addLaterNote: 'Μπορείτε να το προσθέσετε ανά πάσα στιγμή από τις Ρυθμίσεις Οργανισμού',
    doneTitle: 'Είστε έτοιμοι!',
    doneSubtitle: 'Μπορείτε τώρα να δημιουργήσετε το πρώτο σας έργο και να εκμεταλλευτείτε όλες τις δυνατότητες του eazyproject.',
    doneBtn: 'Ξεκινήστε →',
    openaiSteps: ['Πηγαίνετε στο ', 'Πατήστε "Create new secret key"', 'Αντιγράψτε το key και επικολλήστε το παρακάτω'] as [string, string, string],
    anthropicSteps: ['Πηγαίνετε στο ', 'Πατήστε "Create Key"', 'Αντιγράψτε το key και επικολλήστε το παρακάτω'] as [string, string, string],
  },

  orgSettings: {
    title: 'Ρυθμίσεις Οργανισμού',
    subtitle: 'Διαχείριση οργανισμού και AI ενσωμάτωσης',
    loading: 'Φόρτωση...',
    orgNameSection: 'Όνομα Οργανισμού',
    orgNamePlaceholder: 'Όνομα οργανισμού',
    save: 'Αποθήκευση',
    saving: 'Αποθήκευση...',
    aiSection: 'AI Ρυθμίσεις',
    aiHint: 'Επιλέξτε το μοντέλο AI και προσθέστε το δικό σας API key (BYO Key).',
    apiKeyLabel: 'API Key',
    keyActive: 'Ενεργό',
    changeKey: 'Αλλαγή Key',
    noKeyWarning: '⚠️ Δεν έχει οριστεί API key. Χρησιμοποιείται το σύστημα default (gpt-4o).',
    aiModelLabel: 'Μοντέλο AI',
    subscriptionSection: 'Συνδρομή',
    planLabel: 'Πλάνο',
    activeBadge: 'ΕΝΕΡΓΟ',
    nextRenewal: 'Επόμενη ανανέωση',
    projectsLabel: 'Έργα',
    usersLabel: 'Χρήστες',
    showPlans: '▼ Αλλαγή Πλάνου',
    hidePlans: '▲ Απόκρυψη πλάνων',
    planChangeNote: 'Η αλλαγή θα προκαλέσει αναλογική χρέωση/πίστωση στον επόμενο λογαριασμό.',
    limitsUnit: (projects: any, users: any) => `${projects ?? '∞'} έργα · ${users ?? '∞'} χρήστες`,
    popular: 'ΔΗΜΟΦΙΛΕΣ',
    perMonth: '/μήνα',
    currentPlan: 'Τρέχον',
    selectPlan: 'Επιλογή',
    trialBanner: 'Βρίσκεστε στη δωρεάν δοκιμή',
    trialBannerSub: 'Αποκτήστε πλήρη πρόσβαση επιλέγοντας ένα πλάνο συνδρομής.',
    redirecting: 'Ανακατεύθυνση...',
    noSubscription: 'Δεν υπάρχει ενεργή συνδρομή.',
    close: 'Κλείσιμο',
    scheduledCancel: '⚠ Προγραμματισμένη ακύρωση',
    reactivating: 'Επαναφορά...',
    reactivateBtn: 'Επαναφορά Συνδρομής',
    cancelBtn: 'Ακύρωση συνδρομής',
    cancelModalTitle: 'Ακύρωση Συνδρομής',
    cancelModalDesc1: 'Η πρόσβαση παραμένει ενεργή έως το τέλος της τρέχουσας περιόδου.',
    cancelModalDesc2: 'Τα δεδομένα σας διατηρούνται πλήρως και μπορείτε να επαναφέρετε τη συνδρομή οποιαδήποτε στιγμή.',
    cancelModalConfirmLabel: 'Πληκτρολογήστε',
    cancelModalConfirmSuffix: 'για επιβεβαίωση:',
    cancelConfirmWord: 'Ακύρωση Συνδρομής',
    backBtn: 'Πίσω',
    cancellingBtn: 'Ακύρωση...',
    confirmBtn: 'Επιβεβαίωση',
    planChangeModalTitle: (name: string) => `Αλλαγή σε πλάνο ${name};`,
    planChangeModalNote: 'Η αλλαγή εφαρμόζεται άμεσα. Θα δημιουργηθεί αναλογική χρέωση/πίστωση στον επόμενο λογαριασμό σας.',
    cancelPlanBtn: 'Ακύρωση',
    changingBtn: 'Αλλαγή...',
    modelDescriptions: {
      'gpt-4o':                    'Συνιστάται · Συμβατό με τα περισσότερα OpenAI API keys',
      'gpt-4o-mini':               'Οικονομικό · Συμβατό με τα περισσότερα OpenAI API keys',
      'gpt-4.1':                   'Απαιτεί πρόσβαση GPT-4.1 — ελέγξτε αν το key σας έχει πρόσβαση',
      'gpt-4.1-mini':              'Απαιτεί πρόσβαση GPT-4.1 — ελέγξτε αν το key σας έχει πρόσβαση',
      'gpt-5':                     '⚠️ Απαιτεί νέο API key με πρόσβαση GPT-5 — δεν λειτουργεί με παλαιότερα keys',
      'gpt-5-mini':                '⚠️ Απαιτεί νέο API key με πρόσβαση GPT-5 — δεν λειτουργεί με παλαιότερα keys',
      'claude-opus-4-7':           'Πιο ισχυρό · Απαιτεί Anthropic API key (sk-ant-...)',
      'claude-sonnet-4-6':         'Συνιστάται · Απαιτεί Anthropic API key (sk-ant-...)',
      'claude-haiku-4-5-20251001': 'Γρήγορο & οικονομικό · Απαιτεί Anthropic API key (sk-ant-...)',
    } as Record<string, string>,
    errorLoadSettings: 'Σφάλμα φόρτωσης ρυθμίσεων',
    successSave: 'Οι ρυθμίσεις αποθηκεύτηκαν',
    errorSave: 'Σφάλμα αποθήκευσης ρυθμίσεων',
    errorKeyPrefix: 'Το API Key πρέπει να ξεκινά με "sk-"',
    errorNameEmpty: 'Το όνομα οργανισμού δεν μπορεί να είναι κενό',
    unsavedConfirm: 'Έχετε μη αποθηκευμένες αλλαγές. Κλείσιμο χωρίς αποθήκευση;',
    successCancelSub: 'Η συνδρομή προγραμματίστηκε για ακύρωση. Θα λάβετε email επιβεβαίωσης.',
    errorCancelSub: 'Σφάλμα ακύρωσης συνδρομής.',
    successReactivate: 'Η συνδρομή σας επαναφέρθηκε επιτυχώς.',
    errorReactivate: 'Σφάλμα επαναφοράς συνδρομής.',
    successChangePlan: 'Το πλάνο άλλαξε επιτυχώς. Θα λάβετε email επιβεβαίωσης.',
    errorChangePlan: 'Σφάλμα αλλαγής πλάνου.',
    errorCheckout: 'Σφάλμα κατά την ανακατεύθυνση στο checkout.',
  },

  superAdmin: {
    backBtn: '← Πίσω',
    logout: 'Αποσύνδεση',
    loading: 'Φόρτωση...',
    statOrgs: 'Οργανισμοί',
    statUsers: 'Χρήστες',
    statProjects: 'Έργα',
    statSubscriptions: 'Ενεργές Συνδρομές',
    statTrial: 'Free Trial',
    details: 'Λεπτομέρειες →',
    orgsTableTitle: 'Οργανισμοί',
    noOrgs: 'Δεν υπάρχουν οργανισμοί',
    colOrg: 'Οργανισμός',
    colPlan: 'Plan',
    colUsers: 'Χρήστες',
    colProjects: 'Έργα',
    colRegistered: 'Εγγραφή',
    colActions: 'Ενέργειες',
    deleteBtn: 'Διαγραφή',
    planLimitsTitle: 'Όρια Πλάνων',
    planLimitsHint: 'Αριθμός έργων και χρηστών ανά πλάνο. Κενό ή 0 = απεριόριστο.',
    colPlanName: 'Πλάνο',
    colMaxProjects: 'Μέγιστα Έργα',
    colMaxUsers: 'Μέγιστοι Χρήστες',
    saveBtn: 'Αποθήκευση',
    savingBtn: 'Αποθήκευση...',
    deleteOrgTitle: 'Διαγραφή Οργανισμού',
    deleteOrgAbout: (name: string) => `Πρόκειται να διαγράψετε τον οργανισμό "${name}".`,
    deleteOrgWarning: 'Θα διαγραφούν όλα τα έργα, οι χρήστες και τα δεδομένα. Η ενέργεια είναι μη αναστρέψιμη.',
    cancelBtn: 'Ακύρωση',
    confirmDeleteBtn: 'Διαγραφή',
    trialModalTitle: 'Λογαριασμοί Free Trial',
    trialSummary: (active: number, expired: number, total: number) => `${active} ενεργοί · ${expired} ληγμένοι · ${total} συνολικά`,
    filterAll: 'Όλοι',
    filterActive: 'Ενεργοί',
    filterExpired: 'Ληγμένοι',
    noTrials: 'Δεν υπάρχουν λογαριασμοί trial',
    noResults: 'Δεν υπάρχουν αποτελέσματα',
    colTrialOrg: 'Οργανισμός / Email',
    colTrialRegistered: 'Εγγραφή',
    colTrialExpiry: 'Λήξη Δοκιμής',
    colTrialProjects: 'Έργα',
    colTrialStatus: 'Κατάσταση',
    trialExpired: 'Ληγμένη',
    trialActive: 'Ενεργή',
    closeBtn: 'Κλείσιμο',
    errorLoadLimits: 'Αποτυχία φόρτωσης ορίων',
    successSaveLimits: (plan: string) => `Τα όρια για το πλάνο ${plan} αποθηκεύτηκαν.`,
    errorSaveLimits: 'Αποτυχία αποθήκευσης.',
  },
};

const en: typeof el = {
  header: {
    home: 'Home',
    changePassword: 'Change Password',
    giveFeedback: 'Give Feedback',
    orgSettings: 'Organization Settings',
    superAdmin: 'Super Admin Panel',
    createOrg: 'New Organization',
    logout: 'Log Out',
    languageLabel: 'EN',
    languageMenu: { el: 'Ελληνικά', en: 'English' },
  },

  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    empty: 'You have no new notifications',
    welcomeTitle: 'Welcome to eazyproject 👋',
    welcomeMessage: 'Take a look at the projects you have access to.',
    taskAssignedTitle: "You've been assigned a task",
    taskAssignedMessage: (task: string, project: string) => `"${task}" in project "${project}"`,
    invitedOrgTitle: 'Added to a new organization',
    invitedOrgMessage: (org: string) => `You're now a member of "${org}"`,
    invitedProjectTitle: 'Added to a new project',
    invitedProjectMessage: (project: string, org: string) => `You're now a member of project "${project}" (${org})`,
  },

  createOrg: {
    title: 'New Organization',
    subtitle: 'Create your own organization in eazyproject',
    nameLabel: 'Organization name',
    namePh: 'e.g. My Company Ltd',
    choosePlan: 'Choose a plan',
    trialName: 'Free Trial',
    trialSub: '10 days full access · No credit card required',
    trialPrice: 'FREE',
    popular: 'POPULAR',
    btnTrial: 'Start free trial →',
    btnPaid: 'Continue to payment →',
    creating: 'Creating...',
  },

  dashboard: {
    loading: 'Loading...',
    projectsTitle: 'Active Projects',
    manageUsers: '👥 Manage Users',
    newProject: '+ New Project',
    newProjectFirst: '+ Create your first project',
    noActive: 'No active projects.',
    planLimitTooltip: (max: number) => `Plan limit: ${max} projects`,
    archiveBadge: 'ARCHIVE',
    tooltipTitle: 'Project details',
    tooltipStatus: 'Status',
    tooltipBudget: 'Budget',
    tooltipDuration: (months: number) => `${months} months`,
    tooltipOpenIssues: 'Open issues',
    tooltipHighRisks: 'High risks',
    tooltipType: 'Type',
    openProject: 'Open →',
    restoreTip: 'Restore to active',
    dragRestore: 'Drag or press ↩ to restore',
    archiveSection: 'Completed · Archived',
    archiveDragHint: '↩ Drag a project to the active area or press the restore button to restore it',
    guestSection: 'External Projects',
    menuArchive: '📦 Archive',
    menuDelete: 'Delete project',
    healthProblem: 'At Risk',
    healthRisk: 'Warning',
    healthOk: 'On Track',
    planLimitTitle: "You've reached your plan's project limit",
    planLimitAdmin: (max: number, unit: string) => `Your plan allows up to ${max} ${unit}. Upgrade to create new projects.`,
    planLimitMember: (max: number, unit: string) => `Your organization's plan allows up to ${max} ${unit}. Contact your admin to upgrade.`,
    planLimitUpgrade: 'Upgrade plan →',
    planLimitProject: (n: number) => n === 1 ? 'project' : 'projects',
    ragTitle: (count: number, name: string) => `AI used ${count} similar projects as a basis for analysis of "${name}"`,
    ragNote: "The new project's risks, schedule and budget have been enriched with data from these projects.",
    ragView: 'View →',
    newProjectModal: 'New Project',
    noAiKeyMsg: '⚠️ No AI key configured — AI features will not be available.',
    addKeyNow: 'Add now →',
    howToGetKey: 'How do I get an AI key?',
    fieldTitle: 'Project Title *',
    titlePlaceholder: 'e.g. Bridge Construction A1',
    fieldDescription: 'Description',
    descPlaceholder: 'Short description...',
    docSection: 'Project Document',
    docLimit: 'PDF · DOCX · up to 30 MB',
    docHint: 'The AI analyzes the contract and automatically generates the initial project overview.',
    contractLabel: 'Contract / Technical Proposal *',
    contractPlaceholder: '📎 Choose file',
    docNote: '💡 For better analysis, upload a project management document — contract, technical proposal, or specifications.',
    aiAnalyzing: '✦ AI is analyzing the documents and searching for similar projects...',
    loadingSteps: [
      'Creating project',
      'Reading document',
      'Analyzing contract...',
      'Creating project modules',
    ],
    cancel: 'Cancel',
    creating: 'Creating...',
    createBtn: 'Create Project',
    errorRequired: 'Project name is required',
    errorNoContract: 'Please upload the contract document',
    errorFileTooLarge: 'File exceeds the 30 MB limit.',
    errorCreate: 'Error creating the project',
    deleteTitle: 'Delete Project',
    deleteAbout: 'You are about to permanently delete the project:',
    deleteIrreversible: 'This action cannot be undone.',
    deleteConfirmLabel: 'Type',
    deleteConfirmWord: 'Delete',
    deleting: 'Deleting...',
    deleteBtn: 'Delete Project',
    archiveTitle: 'Archive Project',
    archiveAbout: 'You are about to archive the project:',
    archiveHint: '💡 In the next step you will record the Lessons Learned for this project.',
    archiveContinue: 'Continue → Lessons Learned',
    lessonsTitle: 'Lessons Learned',
    lessonsType: 'Project Type',
    lessonsTypePlaceholder: 'e.g. SaaS Development...',
    lessonsIndustry: 'Industry',
    lessonsIndustryPh: 'e.g. Public Sector, Telecom...',
    lessonsRating: 'Overall Rating:',
    lessonsRatingBad: '1 Poor',
    lessonsRatingMid: '3 Average',
    lessonsRatingGood: '5 Excellent',
    lessonsTags: 'Key Challenges',
    lessonsWentWell: 'What went well?',
    lessonsWentWellPh: 'A practice that worked well...',
    lessonsWentWrong: 'What didn\'t go well?',
    lessonsWentWrongPh: 'A problem that arose...',
    lessonsKeyLessons: 'Key Lessons',
    lessonsLessonPh: (i: number) => `Lesson ${i + 1}...`,
    lessonsWouldDo: 'What would you do differently?',
    lessonsWouldDoPh: 'If starting from scratch...',
    lessonsAdd: '+ Add',
    lessonsBack: '← Back',
    lessonsComplete: 'Complete & Archive',
    archiving: 'Archiving...',
    portfolioSearch: 'Portfolio Search',
    portfolioTitle: 'Portfolio Search',
    portfolioSubtitle: 'Search lessons from your organization\'s archived projects',
    portfolioSearchPh: 'Describe your new project or search by industry...',
    portfolioSearchBtn: 'Search',
    portfolioNoProjects: 'No archived projects with recorded Lessons Learned.',
    portfolioNoResults: 'No results found for this search.',
    portfolioFallbackNote: 'Search without AI — no AI key configured.',
    portfolioAiNote: 'Results powered by AI analysis.',
    portfolioMatchScore: 'Relevance',
    aiKeyTitle: 'How do I get an AI key?',
    aiKeySteps: [
      {
        title: 'Choose an AI provider',
        body: 'We support OpenAI (GPT models) and Anthropic (Claude). Create an account with your preferred provider:',
      },
      {
        title: 'Add a payment method',
        body: 'The API key does not work without an active credit balance. Go to your provider\'s billing settings and add a card or purchase credits.',
        note: 'Usage costs are very low — usually a few cents per document analysis.',
      },
      {
        title: 'Create an API key',
        body: "In your provider's dashboard: API Keys → Create new key. Copy the key — it's only shown once.",
      },
      {
        title: 'Paste the key here',
        body: 'Organization Settings → AI Settings → paste the key, select model → Save.',
      },
    ],
    aiKeyGoSettings: 'Go to Settings →',
  },

  projectHub: {
    loading: 'Loading...',
    myProjects: 'My Projects',
    saving: 'Saving...',
    editNameTitle: 'Edit name',
    active: 'Active',
    groupPlanning: 'PLANNING & KICKOFF',
    groupExecution: 'EXECUTION & MONITORING',
    groupAI: 'AI & DOCUMENTS',
    startDate: 'Start:',
    endDate: 'End:',
    aiAssistantTitle: 'AI Assistant',
    chatExpand: 'Expand',
    chatCollapse: 'Collapse',
    thinking: '✦ Thinking...',
    chatPlaceholder: 'Ask something about the project...',
    chatError: 'An error occurred.',
    chatGreeting: (name: string) => `Hello! I'm the AI Assistant for **${name}**.\n\nHow can I help?`,
    quickQuestions: ["How's the project?", 'What are the risks?', 'Any open issues?'] as [string, string, string],
    statRisks: (n: number) => `${n} risks`,
    statCritical: (n: number) => `${n} critical`,
    statPhase: (n: number) => `Phase ${n}`,
    statSchedule: (phases: number, activities: number) => `${phases} phases · ${activities} activities`,
    statOpenIssues: (n: number) => `${n} open`,
    statOverdue: (n: number) => `${n} overdue`,
    statMembers: (n: number) => `${n} members`,
    moduleDescriptions: {} as Record<string, string>,
    dateLocale: 'en-US',
  },

  userManagement: {
    breadcrumbTitle: 'User Management',
    panelTitle: 'Users',
    newUserBtn: '+ New',
    loading: 'Loading...',
    planLimitMsg: (max: number) => `You have reached the maximum of ${max} users on your plan. Upgrade to add more.`,
    emptyState: 'Select a user to manage their permissions',
    manageTitle: (name: string) => `Management — ${name}`,
    fullAccessRole: (role: string) => `The ${role} role automatically has access to all projects and modules.`,
    tabProjects: '🏗️ Project Access',
    tabModules: '🔧 Module Permissions',
    projectsDesc: 'Select which projects this user can access.',
    addToProject: 'Add',
    removeFromProject: 'Remove',
    selectProjectLabel: 'Select Project:',
    selectProjectPlaceholder: '-- Select project --',
    noProjectsWarning: '⚠️ First add the user to a project from the "Project Access" tab.',
    newUserTitle: 'New User',
    emailLabel: 'Email *',
    checking: 'Checking...',
    alreadyInOrg: '⚠️ This user already belongs to your organization.',
    close: 'Close',
    userFoundTitle: (name: string) => `User ${name} was found in the system.`,
    userFoundDesc: 'They will be invited to your organization and will gain access to the selected project.',
    orgRoleLabel: 'Organization role *',
    accessProjectLabel: 'Access project',
    accessProjectOptional: '(optional)',
    noProjectOption: '-- No specific project --',
    pmProjectsLabel: 'Project Access (PM) *',
    pmProjectsHint: 'The PM will have full rights only on the projects you select here.',
    pmProjectsEmpty: 'No projects yet.',
    cancel: 'Cancel',
    inviting: 'Inviting...',
    invite: 'Invite',
    nameLabel: 'Full Name *',
    namePlaceholder: 'e.g. John Smith',
    passwordLabel: 'Password *',
    roleLabel: 'Role *',
    emailNote: '📧 An email with login credentials will be sent to the user.',
    creating: 'Creating...',
    create: 'Create',
    editTitle: 'Edit User',
    saving: 'Saving...',
    save: 'Save',
    deleteTitle: 'Delete User',
    deleteIrreversible: 'This action cannot be undone',
    deleteWarning: 'The user will be deleted along with all their permissions across all projects.',
    deleting: 'Deleting...',
    deleteBtn: 'Delete',
    errorRequired: 'All fields are required',
    errorCreate: 'Error creating user',
    errorUpdate: 'Error updating user',
    errorInvite: 'Error sending invitation',
    editTip: 'Edit',
  },

  app: {
    subscriptionExpiredTitle: 'Your subscription has expired',
    subscriptionExpiredDesc: 'Your data is safe and fully retained.',
    subscriptionExpiredNote: 'Renew your subscription to regain access.',
    renewBtn: 'Renew Subscription →',
    logout: 'Log Out',
    trialExpiredTitle: 'Choose the plan that fits you',
    trialExpiredDesc: 'Your free trial has ended. Select a plan for full access.',
    selectPlanTitle: 'Select Plan',
    selectPlanDesc: 'Billing starts immediately after payment is completed.',
    planLimitsText: (maxProjects: any, maxUsers: any) => `${maxProjects ?? '∞'} projects · ${maxUsers ?? '∞'} users`,
    popular: 'POPULAR',
    perMonth: '/mo',
    redirecting: 'Redirecting...',
    select: 'Select',
    backBtn: '← Back',
    errorCheckout: 'Error redirecting to checkout',
  },

  profileEdit: {
    title: 'My Profile',
    roleLabel: 'Role',
    sectionTitle: 'Change Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    newPasswordPlaceholder: 'At least 6 characters',
    close: 'Close',
    saving: 'Saving...',
    changeBtn: 'Change Password',
    errorRequired: 'All fields are required',
    errorMinLength: 'New password must be at least 6 characters',
    errorMismatch: 'Passwords do not match',
    successMsg: 'Password changed successfully!',
    errorGeneric: 'Error changing password',
  },

  onboarding: {
    errorGeneric: 'Something went wrong. Please try again.',
    welcomeTitle: 'Welcome to eazyproject!',
    welcomeSubtitle: (name: string) => `The organization ${name} is ready. Let us help you get started in 2 quick steps.`,
    welcomeBtn: "Let's go →",
    aiTitle: 'Activate AI',
    aiSubtitle: 'The AI analyzes documents, identifies risks and gives you real-time advice. You need an API key — it takes ',
    aiSubtitleBold: '2 minutes',
    aiSubtitleEnd: ' and you only pay for what you use.',
    creditsNote: 'Make sure there are credits in your account (',
    creditsLink: 'manage credits',
    creditsNoteEnd: ')',
    saveAndContinue: 'Save & Continue →',
    continueBtn: 'Continue →',
    saving: 'Saving...',
    laterBtn: 'Later',
    addLaterNote: 'You can add it at any time from Organization Settings',
    doneTitle: "You're ready!",
    doneSubtitle: 'You can now create your first project and take full advantage of all eazyproject features.',
    doneBtn: 'Get started →',
    openaiSteps: ['Go to ', 'Click "Create new secret key"', 'Copy the key and paste it below'] as [string, string, string],
    anthropicSteps: ['Go to ', 'Click "Create Key"', 'Copy the key and paste it below'] as [string, string, string],
  },

  orgSettings: {
    title: 'Organization Settings',
    subtitle: 'Organization and AI integration management',
    loading: 'Loading...',
    orgNameSection: 'Organization Name',
    orgNamePlaceholder: 'Organization name',
    save: 'Save',
    saving: 'Saving...',
    aiSection: 'AI Settings',
    aiHint: 'Select the AI model and add your own API key (BYO Key).',
    apiKeyLabel: 'API Key',
    keyActive: 'Active',
    changeKey: 'Change Key',
    noKeyWarning: '⚠️ No API key set. Using system default (gpt-4o).',
    aiModelLabel: 'AI Model',
    subscriptionSection: 'Subscription',
    planLabel: 'Plan',
    activeBadge: 'ACTIVE',
    nextRenewal: 'Next renewal',
    projectsLabel: 'Projects',
    usersLabel: 'Users',
    showPlans: '▼ Change Plan',
    hidePlans: '▲ Hide plans',
    planChangeNote: 'The change will result in a prorated charge/credit on your next invoice.',
    limitsUnit: (projects: any, users: any) => `${projects ?? '∞'} projects · ${users ?? '∞'} users`,
    popular: 'POPULAR',
    perMonth: '/mo',
    currentPlan: 'Current',
    selectPlan: 'Select',
    trialBanner: "You're on the free trial",
    trialBannerSub: 'Get full access by selecting a subscription plan.',
    redirecting: 'Redirecting...',
    noSubscription: 'No active subscription.',
    close: 'Close',
    scheduledCancel: '⚠ Cancellation scheduled',
    reactivating: 'Reactivating...',
    reactivateBtn: 'Reactivate Subscription',
    cancelBtn: 'Cancel subscription',
    cancelModalTitle: 'Cancel Subscription',
    cancelModalDesc1: 'Access remains active until the end of the current period.',
    cancelModalDesc2: 'Your data is fully retained and you can reactivate at any time.',
    cancelModalConfirmLabel: 'Type',
    cancelModalConfirmSuffix: 'to confirm:',
    cancelConfirmWord: 'Cancel Subscription',
    backBtn: 'Back',
    cancellingBtn: 'Cancelling...',
    confirmBtn: 'Confirm',
    planChangeModalTitle: (name: string) => `Switch to ${name} plan?`,
    planChangeModalNote: 'The change takes effect immediately. A prorated charge/credit will be applied to your next invoice.',
    cancelPlanBtn: 'Cancel',
    changingBtn: 'Changing...',
    modelDescriptions: {
      'gpt-4o':                    'Recommended · Compatible with most OpenAI API keys',
      'gpt-4o-mini':               'Budget-friendly · Compatible with most OpenAI API keys',
      'gpt-4.1':                   'Requires GPT-4.1 access — check if your key has access',
      'gpt-4.1-mini':              'Requires GPT-4.1 access — check if your key has access',
      'gpt-5':                     '⚠️ Requires new API key with GPT-5 access — does not work with older keys',
      'gpt-5-mini':                '⚠️ Requires new API key with GPT-5 access — does not work with older keys',
      'claude-opus-4-7':           'Most powerful · Requires Anthropic API key (sk-ant-...)',
      'claude-sonnet-4-6':         'Recommended · Requires Anthropic API key (sk-ant-...)',
      'claude-haiku-4-5-20251001': 'Fast & affordable · Requires Anthropic API key (sk-ant-...)',
    } as Record<string, string>,
    errorLoadSettings: 'Error loading settings',
    successSave: 'Settings saved',
    errorSave: 'Error saving settings',
    errorKeyPrefix: 'API Key must start with "sk-"',
    errorNameEmpty: 'Organization name cannot be empty',
    unsavedConfirm: 'You have unsaved changes. Close without saving?',
    successCancelSub: 'Subscription scheduled for cancellation. You will receive a confirmation email.',
    errorCancelSub: 'Error cancelling subscription.',
    successReactivate: 'Your subscription has been successfully reactivated.',
    errorReactivate: 'Error reactivating subscription.',
    successChangePlan: 'Plan changed successfully. You will receive a confirmation email.',
    errorChangePlan: 'Error changing plan.',
    errorCheckout: 'Error redirecting to checkout.',
  },

  superAdmin: {
    backBtn: '← Back',
    logout: 'Log Out',
    loading: 'Loading...',
    statOrgs: 'Organizations',
    statUsers: 'Users',
    statProjects: 'Projects',
    statSubscriptions: 'Active Subscriptions',
    statTrial: 'Free Trial',
    details: 'Details →',
    orgsTableTitle: 'Organizations',
    noOrgs: 'No organizations',
    colOrg: 'Organization',
    colPlan: 'Plan',
    colUsers: 'Users',
    colProjects: 'Projects',
    colRegistered: 'Registered',
    colActions: 'Actions',
    deleteBtn: 'Delete',
    planLimitsTitle: 'Plan Limits',
    planLimitsHint: 'Number of projects and users per plan. Empty or 0 = unlimited.',
    colPlanName: 'Plan',
    colMaxProjects: 'Max Projects',
    colMaxUsers: 'Max Users',
    saveBtn: 'Save',
    savingBtn: 'Saving...',
    deleteOrgTitle: 'Delete Organization',
    deleteOrgAbout: (name: string) => `You are about to delete the organization "${name}".`,
    deleteOrgWarning: 'All projects, users and data will be deleted. This action is irreversible.',
    cancelBtn: 'Cancel',
    confirmDeleteBtn: 'Delete',
    trialModalTitle: 'Free Trial Accounts',
    trialSummary: (active: number, expired: number, total: number) => `${active} active · ${expired} expired · ${total} total`,
    filterAll: 'All',
    filterActive: 'Active',
    filterExpired: 'Expired',
    noTrials: 'No trial accounts',
    noResults: 'No results',
    colTrialOrg: 'Organization / Email',
    colTrialRegistered: 'Registered',
    colTrialExpiry: 'Trial Expiry',
    colTrialProjects: 'Projects',
    colTrialStatus: 'Status',
    trialExpired: 'Expired',
    trialActive: 'Active',
    closeBtn: 'Close',
    errorLoadLimits: 'Failed to load limits',
    successSaveLimits: (plan: string) => `Limits for plan ${plan} saved.`,
    errorSaveLimits: 'Failed to save.',
  },
};

export { el, en };
export type AppStrings = typeof el;
